export default __webpack_public_path__ + "static/media/close.aef77e5c.svg";